function fmtMoeda(v) {
  return (Number(v) || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}
function fmtData(d) {
  return d ? new Date(d + 'T00:00').toLocaleDateString('pt-BR') : '—';
}
function diasAtraso(dataStr) {
  if (!dataStr) return 0;
  const hojeStr = new Date().toISOString().split('T')[0];
  return Math.max(0, Math.floor((new Date(hojeStr) - new Date(dataStr)) / 86400000));
}

function agruparPorMes(cobrancas) {
  const mapa = {};
  cobrancas.forEach(c => {
    const mes = (c.data_prevista || '').slice(0, 7);
    if (!mes) return;
    if (!mapa[mes]) mapa[mes] = [];
    mapa[mes].push(c);
  });
  return Object.entries(mapa).sort((a, b) => a[0].localeCompare(b[0]));
}

const NOMES_MES = ['Janeiro','Fevereiro','Março','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'];

export default function PortalFinanceiro({ cobrancas }) {
  if (!cobrancas.length) {
    return <div className="portal-estado">Nenhum lançamento financeiro ainda para este projeto.</div>;
  }

  const grupos = agruparPorMes(cobrancas);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      {grupos.map(([mes, itens]) => {
        const [ano, m] = mes.split('-');
        const total = itens.reduce((s, c) => s + (Number(c.valor_total) || 0), 0);
        const recebido = itens.filter(c => c.status === 'Recebido').reduce((s, c) => s + (Number(c.valor_total) || 0), 0);
        return (
          <div key={mes}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
              <span style={{ fontWeight: 700, fontSize: 14, color: 'var(--text-primary)', fontFamily: 'Playfair Display, serif' }}>
                {NOMES_MES[Number(m) - 1]} {ano}
              </span>
              <span style={{ fontSize: 12, color: 'var(--text-secondary)' }}>
                {fmtMoeda(recebido)} recebido de {fmtMoeda(total)}
              </span>
            </div>
            <div className="card" style={{ overflow: 'hidden' }}>
              {itens.map((c, i) => {
                const dias = c.status !== 'Recebido' ? diasAtraso(c.data_prevista) : 0;
                const atrasado = dias > 0;
                return (
                  <div key={c.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', borderBottom: i < itens.length - 1 ? '1px solid rgba(107,33,168,0.06)' : 'none', background: atrasado ? '#fff8f8' : 'transparent', borderLeft: atrasado ? '3px solid #dc2626' : '3px solid transparent' }}>
                    <div>
                      <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-primary)' }}>{c.descricao}</div>
                      <div style={{ fontSize: 11, color: atrasado ? '#dc2626' : 'var(--text-secondary)', marginTop: 2, fontWeight: atrasado ? 600 : 400 }}>
                        {c.status === 'Recebido' ? `Recebido em ${fmtData(c.data_recebimento)}` : atrasado ? `Venceu em ${fmtData(c.data_prevista)} · ${dias} dia${dias > 1 ? 's' : ''} em atraso` : `Previsto para ${fmtData(c.data_prevista)}`}
                      </div>
                    </div>
                    <div style={{ textAlign: 'right' }}>
                      <div style={{ fontSize: 15, fontWeight: 800, color: 'var(--purple)', fontFamily: 'Playfair Display, serif' }}>{fmtMoeda(c.valor_total)}</div>
                      <span style={{ background: c.status === 'Recebido' ? '#dcfce7' : atrasado ? '#fee2e2' : '#fef3c7', color: c.status === 'Recebido' ? '#16a34a' : atrasado ? '#dc2626' : '#92400e', padding: '2px 9px', borderRadius: 20, fontSize: 10, fontWeight: 700 }}>
                        {c.status === 'Recebido' ? 'Recebido' : atrasado ? '⚠ Em atraso' : 'Pendente'}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}
